import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { Appointment } from '../../models/appointment.model';

/**
 * Base class for appointment modals with confirm/cancel/close (e.g. cancel-appointment-modal, mark-complete-modal).
 * Shared @Input/@Output and onConfirm/onCancel/onClose handlers.
 */
@Directive({ standalone: true })
export abstract class AppointmentActionModalBase {
  @Input() isVisible = false;
  @Input() appointment: Appointment | null = null;
  @Output() confirm = new EventEmitter<Appointment>();
  @Output() cancel = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();

  onConfirm(): void {
    if (this.appointment) {
      this.confirm.emit(this.appointment);
    }
  }

  onCancel(): void {
    this.cancel.emit();
  }

  onClose(): void {
    this.close.emit();
  }
}
